import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

declare var liff: any;

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }
  //#region Setting config
  public getJSON(): Observable<any> {
    return this.http.get('assets/setting-config/setting.json');
  }
  public async getConfig() {
    await Promise.all([
      this.getJSON().toPromise().then(async data => {
        environment.redirectUri = data.redirectUri;
        environment.serverUrl = data.serverUrl;
        environment.liffId = data.liffId;
        console.log('Test......');
        console.log(environment);
      })
    ]);
  }
  //#endregion Setting config

  //#region Line SDK SERVICE
  async initLineLiffSDK() {
    return new Promise(async (resolve, reject) => {
      await this.getConfig();
      liff.init({ liffId: environment.liffId }).then((data: any) => {
        if (liff.isLoggedIn()) {
          // The user can use an API that requires an access token, such as liff.getProfile().
          resolve(liff.getProfile())
        } else {
          liff.login({ redirectUri: environment.redirectUri })
          //resolve(liff.getProfile())
        }
      }).catch((err: any) => {
        reject(err)
      })
    })
  }

  getLineProfileSDK() {
    return new Promise((resolve, reject) => {
      liff.getProfile().then((data: any) => {
        resolve(data)
      }).catch((err: any) => {
        reject(err)
      })
    })
  }

  closeWindowSDK() {
    if (liff.isLoggedIn() && liff.isInClient()) {
      liff.closeWindow();
    }
  }

  sendMessagesSDK(messages: string) {
    if (liff.isLoggedIn() && liff.isInClient()) {
      return new Promise((resolve, reject) => {
        liff.sendMessages([
          {
            type: 'text',
            text: messages
          }
        ]).then(() => {
          resolve(true);
        }).catch((err: any) => {
          reject(err);
        })
      });
    }else{
      return false;
    }
  }
  //#endregion Line SDK SERVICE

  //#region API SERVICE
  accessLineUser(data: any) {
    var method = "POST";
    var param = `${environment.serverUrl}accesslineuser`;
    var fromData = this.setFromData(data);
    return this.typeMethodApi(method, param, fromData);
  }

  setFromData(data: any) {
    const formData = new FormData();
    const keys = Object.keys(data);
    for (var keyName in keys) {
      formData.append(keys[keyName], data[keys[keyName]]);
    }
    return formData;
  }

  typeMethodApi(method: string, param: string, data: any): Observable<any> {
    switch (method) {
      case "POST":
        return this.http.post(param, data);
      case "GET":
        return this.http.get(param, data);
      case "PUT":
        return this.http.put(param, data);
      case "DELETE":
        return this.http.delete(param, { params: data });
    }
    return this.getJSON();
  }
  //#endregion API SERVICE
}
